<template>
  <SearchAndFilterWrapper
    :search-label="'Gutschein suchen...'"
    :dialog-title="'Filter Gutscheine'"
    :applied-filters="appliedFilters"
    :apply-filters-fn="applyFilters"
    :reset-pending-fn="resetPending"
    :remove-applied-filter-fn="removeAppliedFilter"
    :clear-all-fn="clearAll"
    @update:search="handleSearch"
  >
    <template v-slot:content>
      <v-row>
        <v-col cols="12" sm="6" class="mb-0 mb-sm-4">
          <div class="text-subtitle-1 mb-2">Coupon Typ</div>
          <v-select
            v-model="pending.type"
            :items="couponTypes"
            placeholder="Coupon Typ auswählen"
            hide-details
            clearable
            variant="solo"
            density="comfortable"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" class="mb-4">
          <div class="text-subtitle-1 mb-2">Status</div>
          <v-select
            v-model="pending.status"
            :items="couponStatus"
            placeholder="Status auswählen"
            hide-details
            clearable
            variant="solo"
            density="comfortable"
          ></v-select>
        </v-col>
      </v-row>
      <div class="mb-4">
        <div class="text-subtitle-1 mb-2">Gültigkeitszeitraum</div>
        <v-row>
          <v-col cols="12" sm="6">
            <v-menu
              v-model="menuValidFrom"
              :close-on-content-click="false"
              transition="scale-transition"
            >
              <template v-slot:activator="{ props }">
                <v-text-field
                  v-bind="props"
                  v-model="pending.validFrom"
                  placeholder="Von"
                  prepend-icon="mdi-calendar"
                  hide-details
                  readonly
                  variant="solo"
                  density="comfortable"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="pending.validFrom"
                hide-title
                @update:modelValue="menuValidFrom = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6">
            <v-menu
              v-model="menuValidTo"
              :close-on-content-click="false"
              transition="scale-transition"
            >
              <template v-slot:activator="{ props }">
                <v-text-field
                  v-bind="props"
                  v-model="pending.validTo"
                  placeholder="Bis"
                  hide-details
                  prepend-icon="mdi-calendar"
                  readonly
                  variant="solo"
                  density="comfortable"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="pending.validTo"
                hide-title
                @update:modelValue="menuValidTo = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </div>
    </template>
  </SearchAndFilterWrapper>
</template>

<script>
import SearchAndFilterWrapper from "@/components/Filters/SearchAndFilterWrapper.vue";

export default {
  name: "CouponSearchAndFilter",
  components: { SearchAndFilterWrapper },
  data() {
    return {
      menuValidFrom: false,
      menuValidTo: false,
      pending: {
        type: null,
        status: null,
        validFrom: null,
        validTo: null,
      },
      applied: {},
      couponTypes: [
        { title: "Prozent", value: "percentage" },
        { title: "Betrag", value: "fixed" },
      ],
      couponStatus: ["Aktiv", "Inaktiv"],
    };
  },
  computed: {
    appliedFilters() {
      const chips = [];
      if (this.applied.type) {
        const label =
          this.applied.type === "percentage" ? "Prozentual" : "Festbetrag";
        chips.push({ type: "type", label: `Typ: ${label}` });
      }
      if (this.applied.status) {
        chips.push({ type: "status", label: `Status: ${this.applied.status}` });
      }
      if (this.applied.validFrom || this.applied.validTo) {
        const from = this.applied.validFrom;
        const to = this.applied.validTo;
        chips.push({
          type: "validity",
          label: `Gültig: ${
            from
              ? Intl.DateTimeFormat("de-DE", {
                  dateStyle: "short",
                }).format(new Date(from))
              : "—"
          } bis ${
            to
              ? Intl.DateTimeFormat("de-DE", {
                  dateStyle: "short",
                }).format(new Date(to))
              : "—"
          }`,
        });
      }
      return chips;
    },
  },
  watch: {
    "$route.query": {
      deep: true,
      handler(newQuery) {
        const filters = this.queryToFilters(newQuery);
        this.applied = JSON.parse(JSON.stringify(filters));
        this.pending = JSON.parse(JSON.stringify(filters));
        this.$emit("update:filters", this.applied);
      },
    },
  },
  methods: {
    filtersToQuery(filters) {
      const query = {};
      if (filters.type) query.type = filters.type;
      if (filters.status) query.status = filters.status;
      if (filters.validFrom) query.validFrom = filters.validFrom;
      if (filters.validTo) query.validTo = filters.validTo;
      return query;
    },
    queryToFilters(query) {
      return {
        type: query.type || null,
        status: query.status || null,
        validFrom: query.validFrom || null,
        validTo: query.validTo || null,
      };
    },
    updateUrlFromFilters(filters) {
      const query = this.filtersToQuery(filters);
      this.$router.replace({ query });
    },
    removeAppliedFilter(chip) {
      if (chip.type === "type") this.applied.type = null;
      if (chip.type === "status") this.applied.status = null;
      if (chip.type === "validity") {
        this.applied.validFrom = null;
        this.applied.validTo = null;
      }
      this.$emit("update:filters", this.applied);
      this.updateUrlFromFilters(this.applied);
    },
    applyFilters() {
      this.applied = JSON.parse(JSON.stringify(this.pending));
      this.$emit("update:filters", this.applied);
      this.updateUrlFromFilters(this.applied);
    },
    clearAll() {
      this.pending = {
        type: null,
        status: null,
        validFrom: null,
        validTo: null,
      };
      this.applied = JSON.parse(JSON.stringify(this.pending));
      this.$emit("update:filters", this.applied);
      this.updateUrlFromFilters(this.applied);
    },
    resetPending() {
      this.pending = JSON.parse(JSON.stringify(this.applied));
    },
    handleSearch(value) {
      this.$emit("update:search", value);
    },
  },
  mounted() {
    const initialFilters = this.queryToFilters(this.$route.query);
    this.applied = JSON.parse(JSON.stringify(initialFilters));
    this.pending = JSON.parse(JSON.stringify(initialFilters));
    this.$emit("update:filters", this.applied);
  },
};
</script>

<style scoped lang="scss">
::v-deep .active-button {
  color: white !important;
  background-color: #0099db !important;
}
</style>
